import { Link, useLocation } from 'react-router-dom';
import { useCallback } from 'react';

export default function ScrollLink({
  to,
  children,
  className,
}: {
  to: string;
  children: React.ReactNode;
  className?: string;
}) {
  const location = useLocation();

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      if (to.startsWith('#')) {
        e.preventDefault();
        const id = to.slice(1);
        if (location.pathname === '/') {
          const el = document.getElementById(id);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
          }
        } else {
          window.location.href = `/${to}`;
        }
      }
    },
    [to, location.pathname]
  );

  if (to.startsWith('#')) {
    return (
      <Link to={`/${to}`} className={className} onClick={handleClick}>
        {children}
      </Link>
    );
  }

  return (
    <Link to={to} className={className}>
      {children}
    </Link>
  );
}